var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { CardWithShadow } from "../components";
import { CardMedia, Divider, Typography, useTheme } from "@mui/material";
import { NationFlagRound } from "@nitra/nkmb-theme";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useTranslation } from "react-i18next";
export var SinglePlayerCard = function (props) {
    var _a;
    var theme = useTheme();
    var title = props.title, surname = props.surname, imageUrl = props.imageUrl, countryCode = props.countryCode, number = props.number, onClickUrl = props.onClickUrl;
    var isIos = useIosContext().isIos;
    var PLACEHOLDER = "/images/placeholder331x331player.png";
    var _b = useState("url(".concat(!!imageUrl ? imageUrl : PLACEHOLDER, ")")), backgroundUrl = _b[0], setBackgroundUrl = _b[1];
    var _c = useState(1), scale = _c[0], setScale = _c[1];
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    var handleImageLoadError = function (error) {
        error.preventDefault();
        setBackgroundUrl(PLACEHOLDER);
    };
    return (_jsxs(CardWithShadow, __assign({ to: onClickUrl, onMouseEnter: function () { return setScale(1.08); }, onMouseLeave: function () { return setScale(1); }, sx: { height: 331, position: "relative", }, fixedWidth: 331 }, { children: [_jsx(CardMedia, { component: "div", onError: handleImageLoadError, sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: backgroundUrl,
                    backgroundSize: "contain",
                    transform: "scale(".concat(scale, ")"),
                    transition: "transform 1.5s",
                } }), _jsx("div", { style: {
                    backgroundImage: "rgba(0, 0, 0, 0.8))",
                    zIndex: 0,
                    height: 71,
                    position: "absolute", left: 0, right: 0, bottom: 0
                } }), _jsx(Divider, { sx: { width: "100%", height: 1, backgroundColor: "secondary.main", position: "absolute", bottom: 72 } }), _jsx(Typography, { children: getLocalizedString(title, currentLang) }), _jsx(Typography, { children: surname }), _jsx(Typography, __assign({ variant: "h2", sx: (_a = {
                        color: "primary.main",
                        position: "absolute",
                        top: theme.spacing(3),
                        left: theme.spacing(3)
                    },
                    _a[theme.breakpoints.down("sm")] = isIos && {
                        '@media (-webkit-min-device-pixel-ratio: 2)': {
                            fontWeight: 500, // Adjust font weight for iPhones
                        },
                    },
                    _a) }, { children: number })), _jsx(NationFlagRound, { sx: {
                    position: "absolute",
                    top: theme.spacing(3),
                    right: theme.spacing(3)
                }, svgProps: {
                    width: "100px",
                    height: "100px"
                }, countryCode: countryCode })] })));
};
